import { render, staticRenderFns } from "./DatepickerInput.vue?vue&type=template&id=963457a4&"
import script from "./DatepickerInput.vue?vue&type=script&lang=js&"
export * from "./DatepickerInput.vue?vue&type=script&lang=js&"
import style0 from "./DatepickerInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports